import React, { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { successMessages } from '@/constants/feedbackMessages'
import { Button, Input, ModalBase } from '@components/atoms'
import { yupResolver } from '@hookform/resolvers/yup'
import { editPasswordSchema } from '@schemas/settings/index.schema'
import { dashboardAPI } from '@services/DashboardAPI'
import { modalCreators } from '@store/ducks/modal'
import { notificationCreators } from '@store/ducks/notification'
import { useAppDispatch, useAppSelector } from '@store/hooks'

type Inputs = {
	password: string
	oldPassword: string
	retypePassword: string
}

export const EditPassword = () => {
	const dispatch = useAppDispatch()
	const [editPassword, { isLoading, isSuccess }] =
		dashboardAPI.useEditPasswodMutation()

	const {
		modal: { modalName },
	} = useAppSelector((state) => state)

	const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm<Inputs>({
		mode: 'onBlur',
		resolver: yupResolver(editPasswordSchema),
	})

	const onSubmit: SubmitHandler<Inputs> = (data) => {
		editPassword({
			password: data.password,
			oldPassword: data.oldPassword,
		})
		dispatch(modalCreators.closeModal())
		reset()
	}

	useEffect(() => {
		if (isSuccess) {
			dispatch(notificationCreators.show(successMessages.updatedPassword))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess])

	return (
		<ModalBase title='Alterar senha' open={modalName === 'editPassword'}>
			<form
				onSubmit={handleSubmit(onSubmit)}
				style={{
					width: '100%',
					marginTop: '32px',
					display: 'flex',
					flexDirection: 'column',
					gap: '24px',
				}}
			>
				<Input
					placeholder='Senha antiga'
					error={errors.oldPassword?.message}
					{...register('oldPassword')}
				/>
				<Input
					placeholder='Nova senha'
					type='password'
					error={errors.password?.message}
					{...register('password')}
				/>
				<Input
					placeholder='Confirmar nova senha'
					type='password'
					error={errors.retypePassword?.message}
					{...register('retypePassword')}
				/>
				<div style={{ display: 'flex', gap: '26px', marginTop: '8px' }}>
					<Button loading={isLoading}>Salvar</Button>
				</div>
			</form>
		</ModalBase>
	)
}
